module.exports = __webpack_public_path__ + "static/media/mobileicon.02d45fd3.svg";